export const themeColors = () => {
  const colorNames = ['primary', 'primary-200', 'secondary', 'secondary-400', 'tertiary-400', 'tertiary', 'purple', 'gray-primary', 'graph-primary', 'graph-secondary', 'graph-tertiary']
  const getColorHex = colorName => getComputedStyle(document.querySelector(`[data-theme=${process.env.VUE_APP_SATELLITE}]`)).getPropertyValue(`--color-${colorName}`)

  return Object.assign({}, ...colorNames.map(key => ({ [key]: getColorHex(key) })))
}
